import styled from 'styled-components';

export const Wrapper = styled.span`
  cursor: help;
  flex-shrink: 0;
`;
